import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerDashboardMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('dashboards', locale)
}
